import { useEffect, Component } from 'react';
import Lenis from 'lenis';
import BrandMarquee from './components/BrandMarquee';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Ecosystem from './components/Ecosystem';
import Platforms from './components/Platforms';
import Difference from './components/Difference';
import Industries from './components/Industries';
import Approach from './components/Approach';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Leadership from './components/Leadership';
import Team from './components/Team';
import SideRails from './components/SideRails';
import QuoteBanner from './components/QuoteBanner';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: 'sans-serif' }}>
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="pt-10 font-body">
      <BrandMarquee />
      <Header />
      <main>
        <Hero />
        <Services />
        <Ecosystem />
        <Leadership />
        <Team />
        <Platforms />
        <Difference />
        <QuoteBanner />
        <Industries />
        <Approach />
        <Contact />
      </main>
      <Footer />
      <SideRails />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Site />
    </ErrorBoundary>
  );
}
